import { ReactIcons, SimpleButton } from "@kalyzee/kalyzee-ui";
import clsx from "clsx";
import React from "react";
import styles from "./BannerButton.module.css";

export interface BannerButtonProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  /** CSS background value (color or gradient) applied inline so it wins over SimpleButton's default bg. */
  background?: string;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const BannerButton: React.FC<BannerButtonProps> = ({
  icon,
  title,
  subtitle,
  background,
  onClick,
  className,
  style,
}) => {
  return (
    <SimpleButton
      className={clsx(styles.banner, className)}
      style={background ? { background, ...style } : style}
      onClick={onClick ?? (() => {})}
      label={
        <>
          <div className={styles.iconCircle}>{icon}</div>
          <div className={styles.text}>
            <span className={styles.title}>{title}</span>
            {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
          </div>
          <ReactIcons.ArrowRight className={styles.arrow} />
        </>
      }
    />
  );
};
